import { useContext, type FunctionComponent } from 'react';
import { getPage } from '../../utils/paginator';
import { SurveyPageContext } from '../context/SurveyPageContext';
import QuestionPage from '../question-page/QuestionPage';

const Container: FunctionComponent = () => {
  const { paginatedSurvey, surveyPage } = useContext(SurveyPageContext);

  if (paginatedSurvey?.has(surveyPage)) {
    const currentQuestionPage = getPage({
      paginatedSurvey,
      page: surveyPage,
      defaultValue: [],
    });
    return <QuestionPage questions={currentQuestionPage} />;
  }

  return <></>;
};

Container.displayName = 'Container';

export default Container;
